import { data } from '../../svg/MarkMessageRead/data';
import { makeIcon } from '../makeIcon';

export const MarkMessageRead = makeIcon(data, 'mark_email_read', 'MarkMessageRead');

export default MarkMessageRead;
